// Generic per-school feature flags. The server computes `user.enabledFeatures` from the OWNER id
// (employees inherit their owner's school). An admin may limit a feature to some roles (`featureRoles`):
// the owner counts as OWNER, an employee by their own roles. UI hint only - the server enforces access.
type FeatureUser = {
  enabledFeatures?: string[];
  featureRoles?: Record<string, string[]>;
  employee?: { roles?: string[] } | null;
};

export function hasFeature(user: FeatureUser | null | undefined, feature: string): boolean {
  if (!user || !Array.isArray(user.enabledFeatures) || user.enabledFeatures.indexOf(feature) === -1) return false;
  const allowedRoles = user.featureRoles?.[feature];
  if (!allowedRoles || !allowedRoles.length) return true;
  const ownRoles = user.employee ? user.employee.roles || [] : ['OWNER'];
  return ownRoles.some((role) => allowedRoles.indexOf(role) !== -1);
}

export const CLIENT_ANALYTICS_FEATURE = 'clientAnalytics';
